import { ElementRef, inject, Injectable, NgZone } from "@angular/core";

@Injectable({ providedIn: "root" })
export class DescriptionScrollService {
	private zone = inject(NgZone);

	addEventListener(descriptionElementRef: ElementRef, eventHandler: EventListenerOrEventListenerObject): void {
		this.zone.runOutsideAngular(() => {
			const scrollContentParent = this.getScrollContentParent(descriptionElementRef);
			if (scrollContentParent) {
				scrollContentParent.addEventListener("scroll", eventHandler);
			}
		});
	}

	removeEventListener(descriptionElementRef: ElementRef, eventHandler: EventListenerOrEventListenerObject): void {
		const scrollContentParent = this.getScrollContentParent(descriptionElementRef);
		if (scrollContentParent) {
			scrollContentParent.removeEventListener("scroll", eventHandler);
		}
	}

	scrollToTop(descriptionElementRef: ElementRef): void {
		const scrollContentParent = this.getScrollContentParent(descriptionElementRef);
		if (scrollContentParent) {
			scrollContentParent.scrollTo({ top: 0, behavior: "smooth" });
		}
	}

	private getScrollContentParent(descriptionElementRef: ElementRef): HTMLElement | null {
		return descriptionElementRef.nativeElement.closest(".scroll-content") as HTMLElement | null;
	}
}
